export const zahtjev_MUP = {
    templateId: 52.2,
    category: 6,
    templateTitle: "Zahtjev za podatke o vlasništvu nad vozilima",
    templateDescription: `<p>Vjerovnik ima pravo prije, tijekom ili nakon postupka ovrhe (ovrha na računima ili bilo koji drugi ovršni postupak protiv fizičke ili pravne osobe), od MUP-a zatražiti podatak o tome je li dužnik vlasnik motornih vozila, radi eventualnog pokretanja ovrhe na motornom vozilu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Kako bi naplatio svoju tražbinu, vjerovnik (ovrhovoditelj) ima pravo zatražiti od MUP-a podatak o tome da li je dužnik (fizička ili pravna) prema evidenciji o registriranim i označenim vozilima upisan kao vlasnik vozila te podatak o vrsti, marki, tipu, modelu, godini proizvodnje, registarskom broju vozila i postojanju tereta na tom vozilu.</p>
    <p>Na temelju dobivenog podatka i dokaza o nemogućnosti ovrhe na računima ovršenika uz dokaz FINA-e o nemogućnosti naplate, vjerovnik može pokrenuti ovrhu na pokretninama odnosno zatražiti provedbu ovrhe na drugom predmetu ili drugim sredstvom (nastavna ovrha).</p>
    <p>HZMO nije dužan postupiti po zahtjevu osobe koja traži podatke o dužniku ako prethodno nisu podmireni troškovi za poduzimanje radnji u iznosu od 20,00 kn, stoga je podnositelj obvezan uz pojedinačni zahtjev za izdavanje potvrde za svakog dužnika, pored prilaganja isprava na kojima se temelji tražbina (služe kao dokaz o postojanju pravnog interesa), priložiti i dokaz o podmirenju naknade u iznosu od 40,00 kn ili priložiti upravne pristojbe u vrijednosti 40,00 kn.</p>
    <p>Ukoliko je dužnik vlasnik vie od jednog vozila, za podatak o vlasništvu nad drugim i svakim idućim vozilom vjerovnik (ovrhovoditelj) je dužan podmiriti dodatnih 20,00 kn upravnih pristojbi odnosno uplatiti na u korist državnog proračuna dodatnih 20,00 kn.</p> 
     <br>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Ovršni zakon.</p> 
    `,
    sides: [
        {
          prefix: "",
          signature: "",
          inputs: [
              {
            type: "input",
            required: true,
            placeholder: "Naziv PU",
          },
          {
            type: "input",
            required: true,
            placeholder: "Naziv PP",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto i poštanski broj",
          },
        ],
          suffix: "",
        }
      ],
    
      headline: "",
     
     title: 'Zahtjev za dostavom podataka o vlasništvu nad vozilima',
     noArticleNumbers: true,
     noArticleTitle: true,
  
     articles: [
      {
        title: "",
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
                      { type: "text", content: "Poštovani,\r\n\r\n"},
                      { type: "text", newline:"true", content: "na temelju članka 18. st. 1. Ovršnog zakona zahtijevamo da nam iz evidencije o registriranim i označenim vozilima dostavite podatak o tome da li je" },
              { type: 'input', value: '', required: true, placeholder: "Ime i prezime / Posl. subjekt" },
              { type: "text", content: "," },
              { type: 'text', content: 'iz',},
              { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
              { type: 'text', content: ',' },
              { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
              { type: "text", content: "," },
              { type: 'text', content: 'OIB:' },
              { type: "input",  required: true,},
              { help: "Ovdje upisujete podatke osobe protiv koje namjeravate pokrenuti ovršni postupak."},
              { type: "text", content: "vlasnik nekog motornog vozila, te ukoliko jest, molimo vas da nam dostavite podatke o vrsti, marki, tipu, modelu, godini proizvodnje, registarskom broju motornog vozila i postojanju eventualnog tereta na tom vozilu." }, 
            ],
          }
        ]
      },
              
                {
                  title: '',
                  mandatory: true,
                  dummy: true,
                  statements: [
                      {
                          type: 'text',
                          mandatory: true,
                          editable: true,
                          content: 'Ovim putem vas pozivamo da nam tražene podatke dostavite u zakonskom roku od 8 dana te vas u tom smislu upozoravamo na odredbu čl. 18. st. 7. Ovršnog zakona.',
                          value: '',
                      }],
              },
              {
                title: '',
                mandatory: true,
                dummy: true,
                statements: [
                    {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Naime, protiv navedene osobe namjeravamo pokrenuti ovršni postupak, a dokaz o postojanju pravno interesa prilažemo uz ovaj Zahtjev.',
                        value: '',
                        help: 'Tijela od kojih se traže podaci, zahtijevaju postojanje pravnog interesa za traženje takvih podataka, stoga je potrebno poslati podatke na temelju kojima se može dokazati pravni interes - Izvod otvorenih stavaka, račun i sl..',
                    }],
            },
              {
                  title: '',
                  mandatory: true,
                  dummy: true,
                  statements: [
                      {
                          type: 'text',
                          mandatory: true,
                          editable: true,
                          content: 'Molimo za hitnost u postupanju.',
                          value: '',
                      }],
              },
              {
                title: "",
                mandatory: false,
                dummy: true,
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      { type: "text", content: "Kontakt telefon:" },
                      { type: 'input', value: '', required: true, },
                      { help: "Ovdje upisujete Vaše kontakt podatke što može biti korisno u slučaju potrebe razjašnjenja ili pitanja tijela koje zaprima zahtjev."},
                    ],
                  }
                ]
              },
              {
                mandatory: true,
                static: true,
                type: 2, // date and place
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      {
                        type: "text",
                        content: "U"
                      },
                      {
                        type: "input",
                        value: "",
                        placeholder: "Upišite mjesto.",
                        required: true,
                      },
                      {
                        type: "text",
                        content: ", dana"
                      },
                      {
                        type: "date",
                        value: new Date(),
                        required: true
                      },
                      {
                        type: "text",
                        content: "godine."
                      }
                    ]
                  },
                ]
              },
                 {
                     mandatory: true,
                     static: true,
                     type: 3,  // signatures
                     statements: [],
                 },
                 {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Prilog: \r\n1) Dokaz o postajanju pravnog interesa \r\n2) Upravna pristojba / dokaz o izvršenoj uplati – 40,00 kn',
                        help: 'Nužno je priložiti dokaz o postojanju pravnog interesa - to mogu biti računi, izvodi iz poslovnih knjiga (izvodi otvorenih stavaka), presude, ugovori i sl..'
                     }
                    ]
                  },
                   {
                      static: true,
                      mandatory: false,
                      type: 4, 
                      statements: [
                        {
                          type: 'text',
                          mandatory: true,
                          editable: true,
                          content: 'Dostaviti:\r\n1) Primatelju zahtjeva \r\n2) Arhiva',
                          help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                        }
                      ]
                    },
             ],
  };
  
  
  
  
  
  
  
  
  
  


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/52.2_zahtjev_MUP.ts